import ts from "typescript";
import type { ArgoCDApplicationSourceResource } from "./argoCDApplicationSourceResource";
import Project = ts.server.Project;
export interface ArgoCDApplicationResource {
    Id: string;
    Name: string;
    KubernetesNamespace: string;
    Annotations: Partial<Record<string, string>>;
    Sources: ArgoCDApplicationSourceResource[];
    ArgoCDGatewayId: string;
}
export const ArgoCDAnnotationKeys = {
    ProjectPrefix: "argo.octopus.com/project",
    OctopusProjectAnnotationKey: function (sourceName: string | null) {
        return !!sourceName ? `${ArgoCDAnnotationKeys.ProjectPrefix}.${sourceName}` : ArgoCDAnnotationKeys.ProjectPrefix;
    },
    TenantPrefix: "argo.octopus.com/tenant",
    OctopusTenantAnnotationKey: function (sourceName: string | null) {
        return !!sourceName ? `${ArgoCDAnnotationKeys.TenantPrefix}.${sourceName}` : ArgoCDAnnotationKeys.TenantPrefix;
    },
    EnvironmentPrefix: "argo.octopus.com/environment",
    OctopusEnvironmentAnnotationKey: function (sourceName: string | null) {
        return !!sourceName ? `${ArgoCDAnnotationKeys.EnvironmentPrefix}.${sourceName}` : ArgoCDAnnotationKeys.EnvironmentPrefix;
    },
    DefaultImageRegistry: "argo.octopus.com/default-container-registry",
    ImageReplacePathsPrefix: "argo.octopus.com/image-replace-paths",
    OctopusImageReplacementPathsKey: function (sourceName: string | null) {
        return !!sourceName ? `${ArgoCDAnnotationKeys.ImageReplacePathsPrefix}.${sourceName}` : ArgoCDAnnotationKeys.ImageReplacePathsPrefix;
    },
} as const;
